<template>
    <div>
      <iframe style="width: 90%; height:560px;" src="https://www.jincheng.website/pdfweb/web.pdf"></iframe>
      <!-- <el-card class="box-card">
        <div style="padding: 20px;">
          <div class="jianliHeader">简历</div>

          <DividLine mode="left" text="个人资料"></DividLine>
          <div style="display: flex;justify-content: space-between;">
            <div class="ziliao">
              <span class="ziliaoItem">姓名：白金成</span>
              <span class="ziliaoItem">性别：男</span>
              <span class="ziliaoItem">出生年月：1995.05</span>
              <span class="ziliaoItem">现居住地：辽宁省大连市</span>
              <span class="ziliaoItem">学 历：硕士</span>
              <span class="ziliaoItem">毕业院校：沈阳工业大学</span>
              <span class="ziliaoItem">手 机：18624323369</span>
              <span class="ziliaoItem">电子邮箱：972829530@qq.com</span>
            </div>
            <img src="../assets/me.png" style="height: 150px;margin-top: 20px;">
          </div>

          <DividLine mode="left" text="教育经历"></DividLine>
          <div class="normalItem">
            2018.09 - 2021.06    沈阳工业大学   电气工程    硕士
          </div>
          <div class="normalItem">
            2013.09 - 2017.06    沈阳工业大学   电气工程及其自动化    本科
          </div>

          <DividLine mode="left" text="在校荣誉及证书"></DividLine>
          <div class="ziliao1">
            <span class="ziliaoItem">计算机二级</span>
            <span class="ziliaoItem">英语四级</span>
            <span class="ziliaoItem">全国研究生数学建模竞赛二等奖</span>
            <span class="ziliaoItem">学业一等奖学金</span>
          </div>

          <DividLine mode="left" text="技能情况"></DividLine>
          <div class="normalItem">
            1、掌握HTML、CSS、JavaScript等基础前端技术，可熟练使用Vue.js进行前端项目开发，使用过Vue生态下的Vue-cli、Axios、Element-ui、Vant、Vux等技术构建项目；有使用uni-app的经验。
          </div>
          <div class="normalItem">
            2、了解.Net技术，掌握C#、SQL，对Power BI有一定的了解。
          </div>
          <div class="normalItem">
            3、可熟练使用Unity做2d游戏，有独立开发的游戏作品。
          </div>
          <div class="normalItem">
            4、了解云服务器、IIS部署、网站备案等，有搭建个人网站的经验(https://www.jincheng.website)
          </div>

          <DividLine mode="left" text="工作经历"></DividLine>
          <div class="normalItem">
            2021.07-2024.02 埃森哲信息技术（大连）有限公司
          </div>

          <DividLine mode="left" text="项目经历"></DividLine>
          <div class="normalItem" style="line-height: 1.8rem;">
            &emsp;&emsp;负责的业务：独立负责某医药公司旗下两个系统的前端开发，目前已完成了药品管理模块、自定义标签模块、新药品说明书、聚合页功能开发等，涉及PC端后台管理系统、移动端微信公众号系统。<br>
            &emsp;&emsp;1.药品管理模块：由于客户需要在系统上不定期的添加新药，而系统当前的所有药品都是写在代码中的，不支持动态修改，因此需要开发一个可以动态添加并管理药品的功能模块。开发此功能首先考虑旧数据、旧系统与新功能的兼容，这里使用Axios从后端数据库获取所有药品信息，并存储在Vue.prototype中作为全局变量，供整个系统调用；在药品管理界面的绘制上引用了Element-ui，并微调CSS使各组件的风格统一；同时增加了药品的语音说明功能，需在管理端上传对应药品的语音文件，并在手机端可播放，这里使用了Element-ui的Upload组件实现。<br>
            &emsp;&emsp;2.自定义标签模块：包含后台管理端的新建标签部分和手机端的标签搜索部分。这个功能的主要难点在于自定义标签有两个层级，即父标签和子标签，在新建文章界面实现点击父标签显示所有子标签，给用户呈现出层级关系；在标签管理界面实现父子关系的建立；在手机端搜索时需要根据用户输入的文字模糊搜索含有此子标签的文章。<br>
            &emsp;&emsp;3.新药品说明书：此需求是用来展示公司新研发的某种药品的说明书，需根据用户发来的UI图还原页面。由于药品说明书展示在手机端，因此必须做响应式设计，这里使用了相对单位、flex布局等实现页面的响应式布局，同时结合Vant UI，灵活使用Tap、Collapse、ImagePreview等组件构建页面。<br>
            &emsp;&emsp;4.聚合页开发：为了满足系统内不断新增的功能及页面，需在admin端开发一个管理所有新页面进入方式的功能，并在手机端以聚合页的形式呈现给所有员工，员工只需在聚合页内点击对应功能的图标即可进入到该页面。需要注意的是，用户输入的链接可能是内部的也可能是外部的，需要用不同的方式进行处理。
          </div>

          <DividLine mode="left" text="个人优势"></DividLine>
          <div class="normalItem">
            1.自学能力较强。自学考研、跨行学习计算机相关知识、自学前端、自学其他编程语言、自学Unity等。
          </div>
          <div class="normalItem">
            2.逻辑思维能力较强。理工科出身，有着扎实的数学、物理基础，对逻辑运算敏感，具有将实际问题或需求快速抽象化为解决方案的能力。
          </div>
          <div class="normalItem">
            3.对编程有着浓厚的兴趣。
          </div>
          <div class="normalItem">
            4.性格温和，面对工作细心负责。
          </div>
        </div>
       
      </el-card> -->
    </div>
</template>

<script>
import DividLine from '../components/dividLine.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    DividLine,
    
  },
  mounted() {
    
  },
  methods:{

  }
}
</script>

<style>
.box-card {
    width: 70%;
    margin-left: 12%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
}
.jianliHeader{
  font-size:4rem;
  color: #008080;
  margin: 70px 0;
}
.ziliao{
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0 0;
}
.ziliaoItem{
  margin-right: 40px;
  margin-bottom: 40px;
  display: inline-block;
  font-size: 1.2rem;
  line-height: 1.4rem;
}
.normalItem{
  font-size: 1.2rem;
  text-align:left;
  margin: 20px 0;
  line-height: 1.6rem;
}
.ziliao1{
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0 0;
}
.el-card__body{
  padding: 0px;
}
</style>